import DemoWrapper from "../../utils/DemoPageWrapper";
/* eslint-disable import/no-webpack-loader-syntax */
import Demo from "./demo";
import DemoSource from "!!raw-loader!./demo.vue";

const config = {
  props: [
    {
      prop: "value",
      description: "绑定值",
      type: "String / Number"
    },
    {
      prop: "value-key",
      description:
        "绑定值参数项，当传入options的value为object时确认value中的属性",
      type: "String / Number"
    },
    {
      prop: "options",
      description: "选项列表，为含有label和value的对象数组",
      type: "Object"
    },
    {
      prop: "size",
      description: "尺寸大小",
      type: "String",
      available: "large、middle、default、small、mini",
      default: "default"
    },
    {
      prop: "type",
      description: "不同显示类型",
      type: "String",
      available: "grey3、highlight、available、shadow",
      default: "grey3"
    },
    {
      prop: "border",
      description: "是否有边框",
      type: "Boolean",
      default: "true"
    },
    {
      prop: "placeholder",
      description: "占位符",
      type: "String",
      default: '"请选择"'
    },
    {
      prop: "multiple",
      description: "是否为多选，样式为简化样式",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "filterable",
      description: "option是否增加过滤功能",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "clearable",
      description: "适用于单选的清空",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "filterMethod",
      description: "自定义过滤函数",
      type: "Function"
    },
    {
      prop: "disabled",
      description: "是否禁用select",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "maxShowNumber",
      description: "最大展示行数",
      type: "Number",
      default: "5"
    },
    {
      prop: "itemHeight",
      description: "每行高度",
      type: "Number",
      default: "30"
    },
    {
      prop: "dropdownWidth",
      description: "下拉列表宽度",
      type: "Number",
      default: "默认和输入框相同"
    },
    {
      prop: "padding",
      description: "输入框边距",
      type: "Number",
      default: "10"
    },
    {
      prop: "splitLine",
      description: "下拉列表是否有分隔线",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "colorNormal",
      description: "下拉列表每项默认颜色是否为浅色",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "isFocus",
      description: "是否为选中态，参考input组件",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "isError",
      description: "是否为错误态，参考input组件",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "extendDirection",
      description: "多层选择，弹框方向",
      type: "String",
      available: "left、right",
      default: "right"
    },
    {
      prop: "boundariesSelector",
      description: "边缘检测元素，参考dropdown组件",
      type: "String"
    }
  ],
  events: [
    {
      name: "change",
      description: "值改变事件，在input事件之后",
      argument: "value"
    },
    {
      name: "select",
      description: "选中事件，在input事件之前",
      argument: "value"
    },
    {
      name: "dropdownShow",
      description: "下拉框展开"
    },
    {
      name: "dropdownHide",
      description: "下拉框隐藏"
    }
  ],
  methods: [],
  slots: []
};

export default DemoWrapper(Demo, DemoSource, config);
